import { render, staticRenderFns } from "./LowValueAssets.vue?vue&type=template&id=6e5ab3fa&"
import script from "./LowValueAssets.vue?vue&type=script&lang=js&"
export * from "./LowValueAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports